import { useEffect } from 'react';

/**
 * Run `reset` when the browser shows this page again from its back/forward
 * cache (Back from Google, from Keycloak, from the console). The page comes
 * back exactly as it was left, so a button that said "Redirecting…" would
 * stay disabled for good.
 */
export function useBackForward(reset: () => void): void {
    useEffect(() => {
        const onShow = (e: PageTransitionEvent) => { if (e.persisted) reset(); };
        window.addEventListener('pageshow', onShow);
        return () => window.removeEventListener('pageshow', onShow);
    }, [reset]);
}
